/* eslint-disable @reatom/unit-naming-rule */
import { atom } from '@reatom/framework'

import { BigNumber as BigNumber_, Order } from '@blade/std-lib'
import { reatomTemporalDistinct } from '@root/shared/lib/reatom'

import { map } from './reatom-pair-metrics'

import type { PairMetrics } from '../model'
import type { PairPeriodStatsModel } from './reatom-pair-metrics'
import type { Atom } from '@reatom/framework'
import type { Pair } from '@root/entities/pair'

export const reatomPairUIModel = (args: {
  pair: {
    holdersCount: Atom<number>
    stats: Record<PairMetrics.MetricsSpan, PairPeriodStatsModel>
    insiders: Atom<Pair.PairHolders>
    snipers: Atom<Pair.PairHolders>
    bundlers: Atom<Pair.PairHolders>
  }
}) => {
  const { pair } = args

  const holdersCountTrendDistinct = reatomTemporalDistinct(pair.holdersCount, {
    milliseconds: 2000,
    order: Order.Number,
  })
  const volumeInUsdTrendDistinctMap = map(pair.stats, (stats) =>
    reatomTemporalDistinct(stats.volumeUsd, {
      milliseconds: 2000,
      order: BigNumber_.order,
    }),
  )
  const snipersInsidersBundlersHoldingAtom = atom((ctx) => {
    const snipers = ctx.spy(pair.snipers).holding
    const insiders = ctx.spy(pair.insiders).holding
    const bundlers = ctx.spy(pair.bundlers).holding
    return snipers.plus(insiders).plus(bundlers)
  })

  return {
    holdersCountTrendDistinct,
    volumeInUsdTrendDistinctMap,
    snipersInsidersBundlersHoldingAtom,
  }
}

export interface PairUIModel extends ReturnType<typeof reatomPairUIModel> {}
